/**************************************************
 * Nombre:       Tarjeta_Tema
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const Tarjeta_Tema = ({tema}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={1}
        >

            <Grid container size={{xs: 3, sm: 3, md: 3}}>
                <img src={tema.icono} style={{width: '80%', height: 'auto'}}/>
            </Grid>

            <Grid container size={{xs: 9, sm: 9, md: 9}}>
                <Typography sx={{fontWeight: 800, fontSize: 16, lineHeight: 1.2}}>{`${tema.nombre}:`} <span
                    style={{fontWeight: 300}}>{tema.descripcion}</span> </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Tema